(function () {
    'use strict';

    angular.module('app')
        .controller('EmailFormController', Controller);

    /* @ngInject */
    function Controller($scope, $timeout, item, ModalService, AlertService, Exportar) {
        var vm = this;

        vm.cargando = false;
        vm.item = item;

        vm.propuestas = [];
        vm.selected = {};
        vm.loading = true;
        vm.dismiss = ModalService.dismiss;

        vm.save = function () {
            vm.cargando = true;
            Exportar.exportar(item);
        };

        vm.clear = function () {
            ModalService.dismiss('cancel');
        };

    }
})();
